import React from 'react';

import { IFeaturedBlogPostFields } from '../../../../types/contentful';

import { getImageData } from '../../../utils/contentful';

import { Text } from '../../Text';
import { BlockContainer, Layout, Column } from '../../Layout';
import { Flexbox } from '../../Flexbox';
import { Button } from '../../Button';
import Link from '../../Link';

import { ImageWrapper, BlogPostHeroImage } from './styles';

export function FeaturedBlogPost({
  blogPost,
  heading
}: IFeaturedBlogPostFields) {
  const { sys, fields } = blogPost ?? {};
  const { title, slug, heroImage } = fields ?? {};

  return (
    <>
      <BlockContainer
        as="section"
        marginBottom={{ 0: 'ml', tablet: 'l', desktop: 'xl' }}
        revealOnScroll={false}
        data-blockid={sys?.id}
        data-eltype="featured-blog-post"
        data-testid="featured-blog-post"
      >
        <Layout gutter={{ 0: 'sm', tablet: 'm', desktop: 'l', max: 'xl' }}>
          <Column size={{ 0: 12, tablet: 7 }}>
            <ImageWrapper>
              <BlogPostHeroImage
                {...getImageData(heroImage)}
                heroImage={true}
                loading="eager"
                width={630}
                height={630}
                layout="responsive"
                objectFit="cover"
                objectPosition="50% 50%"
              />
            </ImageWrapper>
          </Column>
          <Column size={{ 0: 12, tablet: 5 }}>
            <Flexbox
              backgroundColor="featuredBlogPostBg"
              borderRadius={{ 0: 'blogHero_0', desktop: 'blogHero_desktop' }}
              padding={{ 0: ['l', 'ml'] }}
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <Text
                as="h1"
                fontSize={{
                  0: 'h2_0',
                  tablet: 'h2_tablet',
                  desktop: 'h2_desktop'
                }}
                fontWeight="h2"
                marginBottom={{ 0: 'm', desktop: 'l' }}
                textAlign="center"
                colour="featuredBlogPostText"
              >
                {title}
              </Text>
              <Link href={`/blog/${slug}`}>
                <Button buttonColor="light" buttonHoverColor="lightHover">
                  Read more
                </Button>
              </Link>
            </Flexbox>
          </Column>
        </Layout>
      </BlockContainer>
      <BlockContainer
        data-blockid={sys?.id}
        data-eltype="featured-blog-post-subheading"
        marginTop={{ 0: 'ml', tablet: 'l', desktop: 'xl' }}
        marginBottom={{ 0: 'ml', tablet: 'l', desktop: 'xl' }}
        revealOnScroll={false}
      >
        <Layout>
          <Column size={{ 0: 10, tablet: 8, desktop: 6 }}>
            <Text
              as="h1"
              fontSize={{
                0: 'h2_0',
                tablet: 'h2_tablet',
                desktop: 'h2_desktop'
              }}
              fontWeight="h2"
              textAlign="center"
              colour="defaultText"
            >
              {heading}
            </Text>
          </Column>
        </Layout>
      </BlockContainer>
    </>
  );
}
